import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { HowItWorks } from "@/components/HowItWorks";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { ServiceAreas } from "@/components/ServiceAreas";
import { Reviews } from "@/components/Reviews";
import { Faq } from "@/components/Faq";
import { BookingForm } from "@/components/BookingForm";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { StickyBar } from "@/components/StickyBar";

export default function Home() {
    return (
        <div className="bg-[#FBF7F3]">
            <Header />
            <main>
                <Hero />
                <Marquee />
                <Services />
                <HowItWorks />
                <WhyChooseUs />
                <ServiceAreas />
                <Reviews />
                <Faq />
                <BookingForm />
                <Contact />
            </main>
            <Footer />
            <StickyBar />
        </div>
    );
}
